import { AccountIntegration } from "../accountIntegration";
/**
 * Entidad Integration
 * Define las integraciones de terceros disponibles en la plataforma (ej. pasarelas de pago, transportistas).
 * Almacena información sobre el proveedor, categoría y esquema de parámetros requeridos.
 */

export enum IntegrationCategory {
	PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
	SHIPPING_CARRIER = 'SHIPPING_CARRIER',
	MARKETPLACE = 'MARKETPLACE',
	EMAIL_MARKETING = 'EMAIL_MARKETING',
	ANALYTICS = 'ANALYTICS',
	ACCOUNTING = 'ACCOUNTING',
	SOCIAL_MEDIA = 'SOCIAL_MEDIA',
	OTHER = 'OTHER',
}

export enum IntegrationStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	BETA = 'BETA',
	DEPRECATED = 'DEPRECATED',
}

export interface Integration {
	id: string;
	category: IntegrationCategory;
	providerKey: string; // Unique identifier key (e.g., 'stripe', 'mercadopago-marketplace')
	name: string; // Human-readable name (e.g., "Stripe", "Mercado Pago Marketplace")
	slug: string;
	description?: string;
	setupInstructions?: string; // General instructions or link to docs
	logoUrl?: string; // URL to the integration's logo
	requiredParamsSchema?: any; // Define required parameters/credentials structure
	supportedPaymentMethods?: string[]; // List of supported payment methods (e.g., 'visa', 'mastercard', 'american_express', 'bank_transfer', 'cash')
	paymentCanRecapture?: boolean; // Can the payment be recaptured by the provider?
	paymentCanRefund?: boolean; // Can the payment be refunded by the provider?
	status: IntegrationStatus;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date | null;
	order: number;
	/** ISO country codes where this integration is available. Null or empty = all countries. */
	countries?: string[] | null;

	accountIntegration: AccountIntegration | null;
}